module.exports = __webpack_public_path__ + "img/new_photo.f1812d54.jpg";